import { Component, Input, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';

import { AuthService } from '../../../auth/services';
import { BaseComponent } from '../base/base.component';
import { MenuGroup } from '../../models';
import { MenuService, TranslationService } from '../../services';

@Component({
  selector: 'app-top-menu',
  templateUrl: './top-menu.component.html',
  styleUrl: './top-menu.component.scss',
})
export class TopMenuComponent extends BaseComponent implements OnInit {
  @Input() isScannerApp = false;
  @Input() requireCustomerId = false;

  isAuthenticated$: Observable<boolean>;
  menus$: Observable<MenuGroup[]>;
  navbarOpen = false;

  constructor(
    public translationService: TranslationService,
    protected authService: AuthService,
    private menuService: MenuService,
    private router: Router,
  ) {
    super();
  }

  ngOnInit() {
    this.isAuthenticated$ = this.authService.isAuthenticated();
    combineLatest([this.router.events, this.isAuthenticated$])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([event, isAuthenticated]) => {
        if (
          event instanceof NavigationEnd &&
          isAuthenticated &&
          (this.authService.isAdmin || this.authService.customerId || !this.requireCustomerId)
        ) {
          this.menus$ = this.menuService.menus.pipe(
            takeUntil(this.destroy$),
            tap((menus: MenuGroup[]) => this.closeMenus(menus)),
          );
          this.navbarOpen = false;
        }
      });
  }

  toggleNavbar() {
    this.navbarOpen = !this.navbarOpen;
  }

  openMenu(menus: MenuGroup[], menu: MenuGroup) {
    const open = !menu.open;
    this.closeMenus(menus);
    menu.open = open;
  }

  closeMenus(menus: MenuGroup[]) {
    menus.forEach((x: MenuGroup) => (x.open = false));
  }
}
